// Shared parser for multi-column TargetingList bulk-paste textareas — used by
// both QARules.js's ListManagePanel ("Create new list") and TargetingLists.js
// (List Management's own "Add Items"). One line per row, columns separated by
// a tab (pasted straight from a spreadsheet) or comma. `columns` is the
// list's full ordered column set (columns[0] is the row's primary/`.value`
// field) — see TargetingList.columns on the backend.
export function parseMultiColumnPaste(text, columns) {
  return text.split('\n').map(l => l.trim()).filter(Boolean).map(line => {
    const parts = (line.includes('\t') ? line.split('\t') : line.split(',')).map(p => p.trim());
    const row = {};
    columns.forEach((col, i) => { row[col] = parts[i] || ''; });
    return row;
  });
}
